<template>
  <section class="services-area ptb-70 bg-f7fafd">
    <div class="container-fluid p-0">
      <div class="overview-box">
        <div class="overview-image">
          <div class="image">
            <img src="assets/img/2.png" alt="image" />
          
          </div>
        </div>
        <div class="overview-content">
          <div class="content">
            <h2>USSD Payments</h2>
      
            <p>
              iRechargePay aggregates the USSD codes of all commercial banks and makes it possible for customers to make payment for goods and services using their bank’s USSD codes. USSD technology is compatible with all GSM phones and does not require internet data
            </p>
            <ul class="services-list">
              <li>
                <span>
                  <i class="flaticon-check-mark"></i> Alternative Payment method. 
                </span>
              </li>
              <li>
                <span>
                  <i class="flaticon-check-mark"></i>Supports all GSM phones
                </span>
              </li>
              <li>
                <span>
                  <i class="flaticon-check-mark"></i>  Does not require internet
                </span>
              </li>
              <li>
                <span>
                  <i class="flaticon-check-mark"></i> Instant notification/confirmation
                </span>
              </li>
              <li>
                <span>
                  <i class="flaticon-check-mark"></i> Robust administrative dashboard
                </span>
              </li>
              <li>
                <span>
                  <i class="flaticon-check-mark"></i> Custom Settlement Schedules
                </span>
              </li>
               <li>
                <span>
                  <i class="flaticon-check-mark"></i>30 sec turnaround time.
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style scoped>
</style>